module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/montaza/montaza-kalendar/montaza-kalendar.component.scss
// module id = ./src/app/components/montaza/montaza-kalendar/montaza-kalendar.component.scss
// module chunks = main